export const STEPS = {
    job: 'job',
    question: 'question',
    info: 'info',
    partner: 'partner'
};
